var $ = require( "jquery" );

window.$ = window.jQuery = require("jquery");

// Load Bootstrap JS
// You can specify which plugins you need
// import { Tooltip, Toast, Popover } from 'bootstrap';

// Load Styles
import '../scss/main.scss';

import PerfectScrollbar from 'perfect-scrollbar';

// App code

export function initEditor() {
    const editor = document.getElementsByClassName('editor')[0];
    if (!editor) {
        return;
    }
    const toolbar = editor.getElementsByClassName('toolbar')[0];
    const buttons = toolbar.querySelectorAll('.editor-btn');
    const contentArea = editor.getElementsByClassName('content-area')[0];
    const visuellView = contentArea.getElementsByClassName('visuell-view')[0];
    const htmlView =  contentArea.getElementsByClassName('html-view')[0];

    for(let i=0; i< buttons.length; i++) {
        const button = buttons[i];
        button.addEventListener('click', function(e) {
            let action = this.dataset.action;
            document.execCommand(action, false);
            htmlView.innerHTML = visuellView.innerHTML;
        });
    }

    ['input', 'blur', 'keyup', 'paste', 'copy', 'cut', 'select', 'undo', 'redo'].forEach(function(eventName) {
        document.addEventListener(eventName, function(e) {
            htmlView.innerHTML = visuellView.innerHTML;
        });
    });

}

let scrollableContent = new Array();

export function updateScrollbars() {
    scrollableContent.forEach(element => { element.update(); });
}

export function destroyScrollbars() {
    scrollableContent.forEach(element => { element.destroy(); });
    scrollableContent = new Array();
}

export function initScrollbars() {
    if (scrollableContent.length) { destroyScrollbars(); }
    let scrollables = document.querySelectorAll('.scrollable');
    if (scrollables) {
        scrollables.forEach(content => scrollableContent.push(new PerfectScrollbar(content, {
                suppressScrollX: true,
                wheelSpeed: .2,
                wheelPropagation: true,
            })
        ));
    }
}

export function initVideos() {
    var players = ['iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="vimeo.com"]', 'iframe[src*="panopto.eu"]'];
    var fitVids = document.querySelectorAll(players.join(","));
    for (var i = 0; i < fitVids.length; i++) {
        // Get Video Information
        var fitVid = fitVids[i];
        var width = fitVid.getAttribute("width");
        var height = fitVid.getAttribute("height");
        var aspectRatio = height / width;
        var parentDiv = fitVid.parentNode;

        // Wrap it in a DIV
        var div = document.createElement("div");
        div.className = "fitVids-wrapper";
        div.style.paddingBottom = aspectRatio * 100 + "%";
        parentDiv.insertBefore(div, fitVid);
        fitVid.remove();
        div.appendChild(fitVid);

        // Clear height/width from fitVid
        fitVid.removeAttribute("height");
        fitVid.removeAttribute("width");
    }
}

export function checkConsentCookie() {
    if (!getCookie("waconcookiemanagement")) {
        $(".waconcookiemanagement").show();
        $(".waconcookiemanagement").focus();
        $(".cookieclose").hide();
    }
}

export function init() {
    checkConsentCookie();
    initConsentKeyboard();
    initFormDialogKeyboard();
    initVideos();
    initEditor();
    initScrollbars();
}

function initFormDialogKeyboard() {
    document.querySelectorAll('#registerModal, #logoutModal').forEach(modal => {
        if (modal.dataset.keyboardReady) return;
        modal.dataset.keyboardReady = 'true';
        modal.addEventListener('keydown', event => {
            if (event.key !== 'Tab') return;
            const controls = Array.from(modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]'))
                .filter(element => !element.disabled && element.getClientRects().length
                    && getComputedStyle(element).visibility !== 'hidden');
            const current = controls.indexOf(document.activeElement);
            if (controls.length && (current === -1 || (!event.shiftKey && current === controls.length - 1)
                || (event.shiftKey && current === 0))) {
                event.preventDefault();
                controls[event.shiftKey ? controls.length - 1 : 0].focus();
            }
        });
    });
}

// Wacon 7 handles Enter itself. Supply Space for its custom controls and keep
// keyboard navigation in the visible panel, including after switching views.
function initConsentKeyboard() {
    const box = document.getElementById('CookieBox');
    if (!box || box.dataset.keyboardReady) return;
    box.dataset.keyboardReady = 'true';
    const visible = element => element.getClientRects().length > 0
        && getComputedStyle(element).visibility !== 'hidden';
    document.addEventListener('keydown', event => {
        if (!visible(box)) return;
        const controls = Array.from(box.querySelectorAll('a[href], button, [tabindex="0"]'))
            .filter(visible);
        if (event.key === 'Tab' && controls.length) {
            const current = controls.indexOf(document.activeElement);
            if (current === -1 || (!event.shiftKey && current === controls.length - 1)
                || (event.shiftKey && current === 0)) {
                event.preventDefault();
                controls[event.shiftKey ? controls.length - 1 : 0].focus();
            }
        } else if (event.key === ' ' && box.contains(event.target)) {
            const control = event.target.closest('[role="button"], [role="switch"]');
            if (control && !control.matches('button, input')) {
                event.preventDefault();
                control.click();
            }
        } else if (event.key === 'Escape') {
            const close = Array.from(box.querySelectorAll('.cookieclose')).find(visible);
            if (close) {
                event.preventDefault();
                close.click();
            }
        }
    });
}

window.onload = (event) => {
    init();

    $(window).resize(function() {
        updateScrollbars();
    });
};

export function showVideo() {
    $('#embed-video').html($('#embed-video').data('content'));
    initVideos();
    $('#embed-video').removeClass('d-none');
    $('#video-overlay').addClass('d-none');
    updateScrollbars();

    $('.task-content-block').animate({scrollTop: $('.task-content-block').height()}, 300);
}

export function showConsent(event) {
    event.stopPropagation();
    event.preventDefault();

    var cookieId = $(event.target).data('cookieid');

    var res = getCookie("waconcookiemanagement");
    var resc = res.split("ts");
    var wert = resc[0];
    if (wert != "") {
        if (wert == "max") {
            $(".cookie-on").show();
            $(".cookie-off").hide();
        }
        else {
            res= wert.split("c");
            jQuery.each( res, function( i, val ) {
                $( ".cookie-on.cookie" + val ).show();
                $( ".cookie-off.cookie" + val ).hide();
            });
        }
    }
    $(".waconcookiemanagement").show();

    $(".cookie-accept").focus();
    if (cookieId) {
        $( ".box-cookie-management" ).show();
        $( ".box-cookie-management" ).focus();
        $( ".cookie-fix" ).show();

        var varGes = $('#CookieBox').height();
        var varFix = $('.cookie-fix').height();
        var neuHeight = varGes - varFix - 100;
        if (neuHeight >= 300) {$('.box-cookie-management').height(neuHeight);}
        if (neuHeight < 300) {$('#CookieBox').css("overflow","auto");}

        $(".intro").hide();
        $( ".info-text" ).hide();

        $(".cookieinfo-" + cookieId).parent().show();
        $(".cookieinfo-" + cookieId).parent().prev().hide();
        $(".cookieinfo-" + cookieId).get(0).scrollIntoView();
    }
}

export function saveConsent(event) {
    event.stopPropagation();
    event.preventDefault();

    var cookieId = $(event.currentTarget).data('cookieid');

    if (cookieId) {
        $(".waconcookiemanagement .cookie-id.cookie" + cookieId)
            .removeClass('cookie-off')
            .addClass('cookie-on')
            .attr('aria-checked', 'true');
    }

    var wert = "";
    $(".waconcookiemanagement .cookie-id.cookie-on").each(function () {
        var serviceClass = this.className.match(/(?:^|\s)cookie(\d+)(?=\s|$)/);
        if (serviceClass) wert += "c" + serviceClass[1];
    });
    if (wert == "") {wert = "min";}
    setCookie("waconcookiemanagement", wert, Date.now());

    $(".waconcookiemanagement").hide();
    location.reload();
}
